import * as React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '../constants';
import { useAuthForTempToken } from '../hooks/useAuthForTempToken';

export default function PrivateRoutewithTempToken({
  children,
}: {
  children: any;
}): React.JSX.Element {
  const { authed } = useAuthForTempToken();
  const location = useLocation();

  return authed ? (
    children
  ) : (
    <Navigate to={ROUTES.LoginPage} replace state={{ path: location.pathname }} />
  );
}
